export default {
  genericPlaceCategories: {

    restaurant: {
      label: 'Restaurant',
      labelPlural: 'Restaurants',
    },

    shop: {
      label: 'Shop',
      labelPlural: 'Shops',
    },

    hotel: {
      label: 'Hotel',
      labelPlural: 'Hotels',
    },

    attraction: {
      label: 'Attraction',
      labelPlural: 'Attractions',
    },

  },
};



// WEBPACK FOOTER //
// ./app/scripts/config/data.js